import { MetaData } from "../../../utils/utils";

export function applyLocationFilter() {
    return MetaData["LocationFilter"] === "true";
}

export function applyOverAndAboveFilter() {
    return MetaData["OverAndAbove"] === "true";
}
export function showskipMarketDetails() {
    return MetaData["showSkipMarketDetails"] === "true";
}
export function isPeriodicWelcome() {
    return MetaData["IsPeriodicWelcome"] === "true";
}

export function applyPieceFilter() {
    return MetaData["piece"] === "true";
}

export function applyCaseFilter() {
    return MetaData["case"] === "true";
}

export function applyInclusionFilter() {
    return MetaData["Inclusion"] === "true";
}

export function applyExclusionFilter() {
    return MetaData["Exclusion"] === "true";
}

export function applyCouponTitleFilter() {
    return MetaData["CouponTitleRequired"] === "true";
}

export function applyNDays(){
    for (const option of MetaData["Recurrence_Options"]) {
        if ('NDays' in option && option["NDays"] === false) {
          return false;
        }
      }
    
      return true;
}

export function applySelectAll(){
    return MetaData["selectAll"]==="true";
}

export function isVersionV1(){
    return MetaData["version"].toLowerCase()==="v1";
}

export function showDistributorDesignation(){
    return MetaData["showDistributorDesignation"]==="true";
}

export function isMustBuyGroupCondition(){
    return MetaData["mustBuyGroupCondition"]==="true";
}